import { useAnyModalOpen } from '@/shared/ui/Modal';
import { useOnboarding } from './context';
import Coachmark from './Coachmark';

// Mounted once (in DefaultLayout) so each step's anchor resolves against
// whatever page is currently on screen.
export default function OnboardingCoachmarks() {
  const { step, next, dismiss } = useOnboarding();
  // Blocking modals (GDPR consent, stake, create-signal…) always win: the
  // coach-mark unmounts while any Modal is open and reappears after.
  const anyModalOpen = useAnyModalOpen();

  if (anyModalOpen || !step) return null;

  return (
    <Coachmark
      // Keyed by path+position so a step change fully remounts the card (a
      // repeated selector across paths — nav-community, or the profile-pill
      // step both paths end on — still resets).
      key={`${step.path}-${step.index}`}
      selector={step.selector}
      title={step.title}
      body={step.body}
      stepIndex={step.index}
      stepCount={step.count}
      onNext={next}
      onSkip={dismiss}
    />
  );
}
